import { IonButton } from '@ionic/react';

export const DeleteMemberButton: React.FC<{ onDelete: () => void; memberLabel: string; }> = ({ onDelete, memberLabel })  => {
    return (
        <div style={{margin: 25, textAlign: 'center', marginTop: 80}}>
            <IonButton data-type="delete-member-button" fill="outline" color="danger" onClick={onDelete}>Delete {memberLabel}</IonButton>
        </div>
    );
};
